import { useEffect } from 'react';
import { usePage } from '@inertiajs/react';

import { loadAwsWafSdk } from '@/components/shared/aws-waf/aws-waf-token';
import type { SharedData } from '@/types/shared';

// Bot Control can challenge any public POST; loading on mount lets the SDK set its token cookie before submit.
export function useAwsWafSdk(enabled = true): string | null | undefined {
  const { awsWafIntegrationScriptUrl } = usePage<SharedData>().props;

  useEffect(() => {
    if (!enabled || !awsWafIntegrationScriptUrl) return;
    void loadAwsWafSdk(awsWafIntegrationScriptUrl);
  }, [enabled, awsWafIntegrationScriptUrl]);

  return awsWafIntegrationScriptUrl;
}
